import colors from "core/colors";
import { palette } from "frontend/components/icons/IconEditor/helpers";

export const iconTransformsInitialState = {
    editorPreview: null,
    queryString: "",
    flipX: false,
    flipY: false,
    rotation: 0
};

export const iconEditorInitialState = {
    fetchingPreviewImage: false,
    fetchingToken: false,
    token: null,
    editCount: 0,
    currentIconId: null,
    iconColors: {
        activeColor: colors.black,
        recent: [colors.black],
        palette
    },
    backgroundColors: {
        activeColor: "None",
        recent: ["None"],
        palette: ["None", ...palette.filter(color => color !== "#00449F")]
    }
};
